import { debuggerMode } from './debugger';

/**
 * Pushes data to GTM's dataLayer global object
 * @param {Object} data Data to push
 */
export default function dlPush(data, callback = null) {
  if (callback) {
    Object.assign(data, { eventCallback: callback });
  }

  if (window.dataLayer) {
    window.dataLayer.push(data);

    if (debuggerMode()) console.info('GTM ➞ Pushed to dataLayer', data);
  } else {
    console.warn('GTM ➞ GTM not available');
  }
}



// WEBPACK FOOTER //
// ./gtm.js